module.exports = __webpack_public_path__ + "img/claim_icon.21cde58c.svg";